var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 184,
    viewBox: "0 0 268 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.53396,
    y: 2.14919,
    width: 263.732,
    height: 179.755,
    rx: 35.2413,
    fill: "white",
    stroke: "white",
    strokeWidth: 3.46636
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.806 133.104C126.72 140.954 114.934 145.693 102.055 145.693C73.3176 145.693 50.0215 122.099 50.0215 92.994C50.0215 63.8891 73.3176 40.2949 102.055 40.2949C114.934 40.2949 126.72 45.0338 135.806 52.8838C144.892 45.0338 156.678 40.2949 169.557 40.2949C198.294 40.2949 221.59 63.8891 221.59 92.994C221.59 122.099 198.294 145.693 169.557 145.693C156.678 145.693 144.892 140.954 135.806 133.104Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.805 133.102C146.992 123.437 154.085 109.054 154.085 92.994C154.085 76.9337 146.992 62.5514 135.805 52.8855C144.891 45.0345 156.678 40.2949 169.558 40.2949C198.295 40.2949 221.591 63.8891 221.591 92.994C221.591 122.099 198.295 145.693 169.558 145.693C156.678 145.693 144.891 140.953 135.805 133.102Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.804 133.102C146.991 123.436 154.084 109.054 154.084 92.9933C154.084 76.933 146.991 62.5507 135.804 52.8848C124.617 62.5507 117.523 76.933 117.523 92.9933C117.523 109.054 124.617 123.436 135.804 133.102Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.bffc13da1d28ee212defffd8e393cbbd.svg";
export { ForwardRef as ReactComponent };